export const getAllowances = (state) => state.allowances
